import {
  defineComponent,
  computed,
  ref,
  onMounted,
} from "@vue/composition-api";
import TipTapDisplay from "@/components/TipTapDisplay/TipTapDisplay.vue";
import { friendlyTimeStamp } from "@/utilities/display-helpers";
import { Editor, EditorContent } from "tiptap";
import { Placeholder } from "tiptap-extensions";
import { BLANK_EDITOR_DOCUMENT } from "@/constants";

import { buildSubmitButton } from "@/utilities/form-helpers";
import { JSConn } from "@/utilities/js-conn";

export default defineComponent({
  name: "mWorkOrderNotes",
  components: {
    TipTapDisplay,
    EditorContent,
  },
  props: {
    workOrderId: {
      type: String,
      required: true,
    },
  },

  setup(props, ctx) {
    let $store = ctx.root.$store;

    let noteContentJSON = ref(BLANK_EDITOR_DOCUMENT);

    let editor = ref<any>(null);

    let { submitButtonText, submitting } = buildSubmitButton();
    submitButtonText.value = "Submit Note";

    const workOrder = computed(() => {
      return $store.getters.workOrder;
    });

    const submitNote = (evt: any) => {
      evt.preventDefault();
      submitting.value = true;
      submitButtonText.value = "Submitting...";

      const jsConn = new JSConn();
      const rightNow = new Date();
      noteContentJSON.value = editor.value.getJSON();

      jsConn.formParams = {
        content_json: noteContentJSON.value,
        work_order_id: props.workOrderId,
        created_at: rightNow,
      };

      $store
        .dispatch("createWorkOrderNote", jsConn)
        .then(() => {
          editor.value.setContent(BLANK_EDITOR_DOCUMENT);
          ctx.root.$nextTick(() => {
            editor.value.focus();
          });
        })
        .then(_jsConn => {
          ctx.emit("notesChanged");
          submitting.value = false;
          submitButtonText.value = "Submit Note";
        });

      noteContentJSON.value = BLANK_EDITOR_DOCUMENT;
    };

    onMounted(() => {
      editor.value = new Editor({
        extensions: [
          new Placeholder({
            emptyEditorClass: "is-empty",
            emptyNodeText: "Write a note...",
            showOnlyWhenEditable: true,
          }),
        ],
      });

      editor.value.setContent(BLANK_EDITOR_DOCUMENT);
    });

    return {
      workOrder,
      friendlyTimeStamp,

      editor,
      submitNote,
      submitting,
      submitButtonText,
    };
  },
});
